<template>
  <div id="home-page">
    <b-loading :active.sync="loading"></b-loading>
    <div class="columns is-mobile">
      <div class="column is-10 is-offset-2">
        <p class="header">{{ today }}</p>
        <p class="sub-header">คุณมีคิวทั้งหมดวันนี้ {{ activities | activeActivitiesLength }} คิว</p>
      </div>
    </div>
    <div class="q-card-container">
      <q-card-overview v-for="act in activities"
                       :key="act.id"
                       :id="act.id"
                       :service-type="act.serviceType"
                       :q-number="act.qNumber"
                       :q-prefix="act.qPrefixMask || act.qPrefix"
                       :q-suffix="act.qSuffixMask || act.qSuffix"
                       :q-type="act.qType"
                       :service-unit-name="act.serviceUnitName"
                       :location="act.location"
                       :appoint-time="act.appointTime"
                       :case-number="act.caseNumber"
                       :case-status="act.caseStatus"
                       :case-message="act.caseMessage"
                       :case-description="act.caseDescription"
                       :text-color="act.textColor">
      </q-card-overview>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { getTodayTH } from '../utils/datetime'
import QCardOverview from '../components/qCardOverview'

export default {
  name: 'HomePage',
  components: {
    QCardOverview
  },
  mounted () {
    this.loading = true
    this.today = getTodayTH()
    this.sessionKey = localStorage.getItem('sessionKey')
    if (this.sessionKey && this.activities && this.activities.length > 0) {
      this.loading = false
    } else if (
      this.sessionKey &&
      (!this.activities || this.activities.length === 0)
    ) {
      this.initData()
        .then(() => {
          this.reloadInterval = setInterval(() => {
            this.initData()
          }, this.reloadDataTime * 60 * 1000)
        })
        .catch((err) => {
          if (err.data.statusCode === 401 || err.status === 401) {
            localStorage.removeItem('sessionKey')
            this.$router.push('/401')
          }
        })
    } else if (!this.sessionKey) {
      this.$router.push('/401')
    }
  },
  data () {
    return {
      loading: true,
      sessionKey: '',
      today: '',
      reloadDataTime: 5 // minute
    }
  },
  filters: {
    activeActivitiesLength (activities) {
      return activities ? activities.filter(a => !['checkedOutDoctor', 'cancel', 'late'].includes(a.currentStatus)).length : 0
    }
  },
  computed: {
    ...mapState(['patientName', 'activities', 'hn'])
  },
  methods: {
    ...mapMutations(['cleanupActivities']),
    ...mapActions(['getActivitiesAction']),
    initData () {
      return this.getActivitiesAction()
        .then(() => {
          this.loading = false
        })
        .catch(err => {
          return Promise.reject(err)
        })
    }
  },
  beforeDestroy () {
    if (this.reloadInterval !== null) {
      clearInterval(this.reloadInterval)
    }
  }
}
</script>

<style lang="scss" scoped>
#home-page {
  padding-top: 130px;

  .header {
    font-family: 'Mitr', sans-serif;
    font-size: 1.125rem;
    color: #454545;
  }

  .sub-header {
    font-family: 'Prajad', sans-serif;
    font-weight: bold;
    font-size: 1rem;
    color: #717171;
  }

  .q-card-container {
    max-width: 340px;
    margin: 0 auto;
  }
}
</style>
